let preferredVoice = null;

function selectVoice(locale) {
  if (typeof window === 'undefined' || !window.speechSynthesis) return null;
  const voices = window.speechSynthesis.getVoices();
  return voices.find((voice) => voice.lang.toLocaleLowerCase('en') === locale.toLocaleLowerCase('en'))
    ?? voices.find((voice) => voice.lang.toLocaleLowerCase('en').startsWith('en-hk'))
    ?? voices.find((voice) => voice.lang.toLocaleLowerCase('en').startsWith('en-gb'))
    ?? voices.find((voice) => voice.lang.toLocaleLowerCase('en').startsWith('en'))
    ?? null;
}

export function speak(text, locale = 'en-HK') {
  const cleaned = String(text ?? '').trim();
  if (!cleaned || typeof window === 'undefined' || !window.speechSynthesis) return false;
  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(cleaned);
  utterance.lang = locale;
  preferredVoice = selectVoice(locale) ?? preferredVoice;
  if (preferredVoice) utterance.voice = preferredVoice;
  utterance.rate = 0.92;
  window.speechSynthesis.speak(utterance);
  return true;
}

export function stopSpeech() {
  if (typeof window !== 'undefined') window.speechSynthesis?.cancel();
}
